import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_CYBER_CARE_PRODUCT_PRICE = 'GET_CYBER_CARE_PRODUCT_PRICE';
export const GET_CYBER_CARE_PRODUCT_PRICE_SUCCESS =
  'GET_CYBER_CARE_PRODUCT_PRICE_SUCCESS';
export const GET_CYBER_CARE_PRODUCT_PRICE_FAILED =
  'GET_CYBER_CARE_PRODUCT_PRICE_FAILED';

export class GetCyberCareProductPrice implements Action {
  type = GET_CYBER_CARE_PRODUCT_PRICE;

  constructor(public payload?: any) {}
}

export class GetCyberCareProductPriceSuccess implements Action {
  type = GET_CYBER_CARE_PRODUCT_PRICE_SUCCESS;

  constructor(public payload: any) {}
}

export class GetCyberCareProductPriceFailed implements Action {
  type = GET_CYBER_CARE_PRODUCT_PRICE_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetCyberCareProductPrice
  | GetCyberCareProductPriceSuccess
  | GetCyberCareProductPriceFailed;
